import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AccountProfileComponent } from '../account-profile/account-profile.component';
import { ApprovalComponent } from '../approval/approval.component';
import { PortalDashComponent } from '../portal-dash/portal-dash.component';
import { PortalProductsComponent } from '../portal-products/portal-products.component';
import { PortalUserProfileComponent } from '../portal-user-profile/portal-user-profile.component';
import { TaskComponent } from '../task/task.component';
import { RouteResolver } from '../../resolvers/route.resover';

const routes: Routes = [
  {
    path: "index", component: PortalDashComponent,
  },
  {path: "yourproducts",component: PortalProductsComponent},
  {path: "task",component: TaskComponent},
  {path: 'acc',component: AccountProfileComponent},
  {path: "profile",component: PortalUserProfileComponent},
  {path: "appr",component: ApprovalComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers:[RouteResolver]
})
export class PortalLayoutsRoutingModule { }
